<div *ngIf="usuarioB.imagem == undefined; then defalut; else usuario"></div>

<div class="back" *ngIf="showModal" (click)="handleOpenModal()">
  <div
    class="modal"
    *ngIf="showModal"
  >
    <div class="modal-content">
      <div class="logout" (click)="logout()">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home">logout</mat-icon>
        <div class="-text">Sair</div>
      </div>


    </div>

  </div>
</div>

<ng-template #usuario>
  <div class="user-detail" (click)="handleOpenModal()">
    <img src="data:image/png;base64,{{usuarioB.imagem}}" alt="foto de perfil da pessoa" class="container-notify foto-perfil" >
    <div class="name-user">
      <span>{{ usuarioB.nome }}</span>
      <mat-icon
        aria-hidden="false" fontIcon=" arrow_drop_down"> arrow_drop_down</mat-icon>
    </div>
  </div>
</ng-template>
<ng-template #defalut>
  <div class="user-detail" (click)="handleOpenModal()">
    <img src="../../../assets/usuario.jpg" class="foto-perfil container-notify" alt="" (click)="handleOpenModal()">
    <div class="name-user">
      <span>{{ usuarioB.nome }}</span>
      <mat-icon
        aria-hidden="false" fontIcon=" arrow_drop_down"> arrow_drop_down</mat-icon>
    </div>

  </div>

</ng-template>
